import { Injectable } from '@angular/core';
import { EntityState, StoreConfig } from '@datorama/akita';
import { Y42EntityStore } from '@y42/state';
import { ChatRoomUIModel } from '../models/chat-room.model';

export interface ChatRoomsState extends EntityState<ChatRoomUIModel, ChatRoomUIModel['id']> {}

const initialState: ChatRoomsState = {};

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'ui-chat-rooms' })
export class ChatRoomsStore extends Y42EntityStore<ChatRoomsState> {
  constructor() {
    super(initialState);
  }
}
